import { getEnabledServices } from './sessionDB';
import { getMobileApp } from './mobileAppRegistry';
import { isServiceEnabled } from './mobileServices';

// Scope menus locally; keep the complete session for switching and fallback.
export function getMenuServices(services = getEnabledServices(), userAgent = navigator.userAgent) {
  const app = getMobileApp(userAgent);
  if (!app) return services;
  return isServiceEnabled(app.service, services) ? { [app.service]: services[app.service] } : {};
}